<div class="dx-card padding-content">
    <dx-data-grid
        height="100%"
        [dataSource]="dataSource"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true"
        [(selectedRowKeys)]="selectedRowKeys"
        (onRowDblClick)="onRowDblClick($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onEditorPreparing)="onEditorPreparing($event)"
        (onRowPrepared)="onRowPrepared($event)"
    >
        <dxo-selection
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="always"
        ></dxo-selection>
        <dxo-toolbar>
            <dxi-item location="before" locateInMenu="auto">
                <dx-button
                    icon="edit"
                    text="Edit"
                    hint="Edit the selected request — select exactly one row"
                    [disabled]="batchRunning || !canEditSelection"
                    (onClick)="editSelected()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="before" locateInMenu="auto">
                <dx-button
                    icon="check"
                    text="Confirm{{
                        batchCounts.confirm
                            ? ' (' + batchCounts.confirm + ')'
                            : ''
                    }}"
                    hint="Confirm selected — collecting → complete"
                    [disabled]="batchRunning || batchCounts.confirm === 0"
                    (onClick)="batchConfirm()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="before" locateInMenu="auto">
                <dx-button
                    icon="taskcomplete"
                    text="Issue{{
                        batchCounts.markIssued
                            ? ' (' + batchCounts.markIssued + ')'
                            : ''
                    }}"
                    hint="Mark selected issued — complete → issued"
                    [disabled]="batchRunning || batchCounts.markIssued === 0"
                    (onClick)="batchMarkIssued()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="before" locateInMenu="auto">
                <dx-button
                    icon="close"
                    text="Cancel{{
                        batchCounts.cancel ? ' (' + batchCounts.cancel + ')' : ''
                    }}"
                    hint="Cancel selected requests"
                    [disabled]="batchRunning || batchCounts.cancel === 0"
                    (onClick)="batchCancel()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="before" locateInMenu="auto">
                <dx-button
                    icon="trash"
                    text="Erase{{
                        batchCounts.erase ? ' (' + batchCounts.erase + ')' : ''
                    }}"
                    hint="PDPA erase selected records"
                    [disabled]="batchRunning || batchCounts.erase === 0"
                    (onClick)="batchErase()"
                ></dx-button>
            </dxi-item>
            <dxi-item name="addRowButton"></dxi-item>
            <dxi-item
                widget="dxButton"
                location="after"
                [options]="refreshButtonOptions"
            ></dxi-item>
            <dxi-item name="columnChooserButton"></dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-pager
            [visible]="true"
            [allowedPageSizes]="[20, 50, 100]"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true"
        ></dxo-pager>

        <dxo-editing
            mode="popup"
            [allowAdding]="true"
            [allowUpdating]="allowUpdating"
            [allowDeleting]="allowDeleting"
            [useIcons]="true"
        >
            <dxo-texts
                confirmDeleteMessage="PDPA erase: permanently removes all personal data from this record and keeps an anonymized stub. Continue?"
            ></dxo-texts>
            <dxo-popup
                title="Invoice Request"
                [showTitle]="true"
                [width]="760"
                height="auto"
            ></dxo-popup>
            <dxo-form [colCount]="2">
                <dxi-item
                    itemType="group"
                    caption="Request"
                    [colSpan]="2"
                    [colCount]="2"
                >
                    <dxi-item dataField="storeId"></dxi-item>
                    <dxi-item dataField="platform"></dxi-item>
                    <dxi-item dataField="source"></dxi-item>
                    <dxi-item dataField="orderSn"></dxi-item>
                    <dxi-item dataField="conversationId"></dxi-item>
                    <dxi-item dataField="buyerUserId"></dxi-item>
                </dxi-item>
                <dxi-item
                    itemType="group"
                    caption="Invoice"
                    [colSpan]="2"
                    [colCount]="2"
                >
                    <dxi-item dataField="invoice.type"></dxi-item>
                    <dxi-item dataField="invoice.legalName"></dxi-item>
                    <dxi-item dataField="invoice.taxId"></dxi-item>
                    <dxi-item dataField="invoice.branchCode"></dxi-item>
                    <dxi-item dataField="invoice.branchName"></dxi-item>
                    <dxi-item dataField="invoice.email"></dxi-item>
                    <dxi-item dataField="invoice.phone"></dxi-item>
                </dxi-item>
                <dxi-item
                    itemType="group"
                    caption="Address"
                    [colSpan]="2"
                    [colCount]="2"
                >
                    <dxi-item
                        dataField="invoice.address.line1"
                        [colSpan]="2"
                    ></dxi-item>
                    <dxi-item dataField="invoice.address.subDistrict"></dxi-item>
                    <dxi-item dataField="invoice.address.district"></dxi-item>
                    <dxi-item dataField="invoice.address.province"></dxi-item>
                    <dxi-item dataField="invoice.address.postalCode"></dxi-item>
                    <dxi-item dataField="invoice.address.country"></dxi-item>
                </dxi-item>
            </dxo-form>
        </dxo-editing>

        <dxi-column
            dataField="id"
            caption="ID"
            [allowEditing]="false"
            [visible]="false"
            [formItem]="{ visible: false }"
        ></dxi-column>
        <dxi-column dataField="storeId" caption="Store">
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="platform" caption="Platform">
            <dxo-lookup [dataSource]="platforms"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="source" caption="Source" [visible]="false">
            <dxo-lookup [dataSource]="sources"></dxo-lookup>
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column
            dataField="status"
            caption="Status"
            [allowEditing]="false"
            cellTemplate="statusCell"
        >
            <dxo-lookup [dataSource]="statuses"></dxo-lookup>
        </dxi-column>
        <div *dxTemplate="let cell of 'statusCell'">
            <span [class]="'status-pill status-' + cell.data.status">{{
                cell.data.status
            }}</span>
        </div>
        <dxi-column dataField="orderSn" caption="Order SN">
            <dxi-validation-rule
                type="pattern"
                pattern="^[A-Za-z0-9_-]{1,64}$"
                message="1–64 characters: letters, digits, _ or -"
            ></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="invoice.type" caption="Type">
            <dxo-lookup
                [dataSource]="invoiceTypes"
                [allowClearing]="true"
            ></dxo-lookup>
        </dxi-column>
        <dxi-column
            dataField="invoice.legalName"
            caption="Legal Name"
        ></dxi-column>
        <dxi-column dataField="invoice.taxId" caption="Tax ID"></dxi-column>
        <dxi-column dataField="invoice.branchCode" caption="Branch">
            <dxi-validation-rule
                type="pattern"
                pattern="^[0-9]{5}$"
                message="5 digits; 00000 = head office"
            ></dxi-validation-rule>
        </dxi-column>
        <dxi-column
            dataField="invoice.branchName"
            caption="Branch Name"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.email"
            caption="Email"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.phone"
            caption="Phone"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="conversationId"
            caption="Conversation"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="buyerUserId"
            caption="Buyer"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="addressText"
            caption="Address"
            [allowEditing]="false"
            [minWidth]="280"
            [formItem]="{ visible: false }"
            cellTemplate="addressCell"
        ></dxi-column>
        <div
            *dxTemplate="let cell of 'addressCell'"
            class="ellipsis-cell"
            [title]="cell.value"
        >
            {{ cell.value }}
        </div>
        <dxi-column
            dataField="invoice.address.line1"
            caption="Address Line 1"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.address.subDistrict"
            caption="Sub-district"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.address.district"
            caption="District"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.address.province"
            caption="Province"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoice.address.postalCode"
            caption="Postal Code"
            [visible]="false"
        >
            <dxi-validation-rule
                type="pattern"
                pattern="^[0-9]{5}$"
                message="5 digits"
            ></dxi-validation-rule>
        </dxi-column>
        <dxi-column
            dataField="invoice.address.country"
            caption="Country"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            name="missingFields"
            caption="Missing"
            [allowEditing]="false"
            [visible]="false"
            [calculateCellValue]="missingFieldsText"
        ></dxi-column>
        <dxi-column
            dataField="erased"
            caption="Erased"
            dataType="boolean"
            [allowEditing]="false"
            [visible]="false"
            [formItem]="{ visible: false }"
        ></dxi-column>
        <dxi-column
            dataField="version"
            caption="Version"
            [allowEditing]="false"
            [visible]="false"
            [formItem]="{ visible: false }"
        ></dxi-column>
        <dxi-column
            dataField="audit.updatedAt"
            caption="Updated"
            dataType="datetime"
            format="yyyy-MM-dd HH:mm"
            [allowEditing]="false"
            sortOrder="desc"
            [formItem]="{ visible: false }"
        ></dxi-column>
        <dxi-column
            dataField="audit.createdAt"
            caption="Created"
            dataType="datetime"
            format="yyyy-MM-dd HH:mm"
            [allowEditing]="false"
            [visible]="false"
            [formItem]="{ visible: false }"
        ></dxi-column>

        <!--
            Declared only to suppress it. In popup edit mode DevExtreme adds a
            command column of its own whenever allowUpdating/allowDeleting are
            set, so deleting the buttons column isn't enough to get rid of the
            row icons — editing runs from the toolbar and double-click instead.
        -->
        <dxi-column type="buttons" [visible]="false"></dxi-column>
    </dx-data-grid>
</div>
